"use client";

import React from "react";
import { Calculator, Database, FileText, CircleQuestionMark } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "Quali sono i tempi medi per l'ottenimento di un visto?",
  answer: "Le tempistiche variano in base alla tipologia di visto e al paese di destinazione. Generalmente, le pratiche aziendali richiedono dalle 4 alle 8 settimane, mentre i visti per studenti possono essere processati in tempi più brevi, tra i 15 e i 30 giorni lavorativi.",
  icon: Calculator
}, {
  question: "Offrite supporto per il ricongiungimento familiare?",
  answer: "Certamente. Gestiamo l'intera procedura di immigrazione per i familiari al seguito, assicurando che tutta la documentazione sia conforme ai requisiti consolari e ministeriali per garantire la massima probabilità di successo della pratica.",
  icon: Database
}, {
  question: "Come vengono gestiti i servizi extragiudiziali?",
  answer: "Il nostro approccio extragiudiziale si focalizza sulla risoluzione amministrativa e sulla mediazione diretta con le autorità competenti. Questo permette di accelerare le pratiche burocratiche evitando lungaggini legali e garantendo un servizio premium e tempestivo.",
  icon: FileText
}];
export default function PayrollInquiries() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="233541" id="domande-frequenti" className="bg-primary py-16 md:py-24 lg:py-32">
      <div ref={ref} className={`container mx-auto max-w-4xl px-4 md:px-6 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="mb-12 text-center">
          <div className="mb-4 inline-flex items-center justify-center rounded-full bg-secondary/10 p-3">
            <CircleQuestionMark className="size-6 text-secondary" />
          </div>
          <h2 className="font-default text-3xl font-bold tracking-tight text-white sm:text-4xl md:text-5xl">
            Domande Frequenti
          </h2>
          <p className="mx-auto mt-4 max-w-[42rem] text-white/80 font-default sm:text-xl sm:leading-8">
            Risposte chiare e professionali sui nostri servizi di mobilità internazionale, visti e consulenza per aziende e privati.
          </p>
        </div>

        <div className="rounded-sm border border-white/10 bg-white/5 p-6 shadow-xl backdrop-blur-sm sm:p-8">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-white/10">
                <AccordionTrigger className="text-base sm:text-lg hover:no-underline group py-6">
                  <div className="flex items-center gap-4 text-left">
                    <div className="flex size-10 shrink-0 items-center justify-center rounded-sm bg-primary border border-secondary/30 shadow-2xs transition-colors group-hover:border-secondary group-hover:bg-secondary/10">
                      <faq.icon className="size-5 text-secondary" />
                    </div>
                    <span className="font-default font-semibold text-secondary">
                      {faq.question}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-white/70 font-default sm:text-base leading-relaxed pl-14 pr-4 pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}